import { Box, styled } from '@mui/material';

export const HistoryContainer = styled(Box)({
  boxSizing: 'border-box',
  overflow: 'auto',
});

export const MessageContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(3, 3, 8, 3),
  flexDirection: 'column',
  justifyContent: 'flex-end',
  alignItems: 'center',
  flex: '1 0 0',
  gap: theme.spacing(3),
  alignSelf: 'stretch',
  minHeight: '100%',
  borderRadius: '16px',
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.paper.dark,
  boxSizing: 'border-box',
  overflowY: 'auto',
}));

export const LoadingIndicator = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  padding: theme.spacing(3),
}));
